import script from "./ModalConfirmReceipt.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalConfirmReceipt.vue?vue&type=script&lang=ts&setup=true"

import "./ModalConfirmReceipt.vue?vue&type=style&index=0&id=552aefd5&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552aefd5"]])

export default __exports__